<!--
Author: TangChen
Date: 2018-02-26
Desc: 购买基金组件，由index.js 配置引入
-->
<template>
    <div class="comp-buy comp">
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundname + "(" + fund.fundcode + ")" }}
                </div>
            </el-form-item>
            <el-form-item label="收费方式：" class="form-text">
                <el-select v-if="fund.sharetype === 'A,B'" v-model="fund.selectShareType">
                    <el-option v-for="item in shareTypeLists" :key="item.value" />
                </el-select>
                <el-select v-else v-model="fund.sharetype" :disabled="true">
                    <el-option
                        v-for="item in shareTypeLists"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-if="fund.payway" label="资金来源：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.way">
                    <el-radio v-if="fund.payway.indexOf('2') > -1" label="2" name="sell">
                        银行卡&nbsp;
                    </el-radio>
                    <el-radio
                        v-if="xjbFundCode != fundInfo.fundcode && xjbFlag"
                        label="1"
                        name="sell"
                    >
                        钱柜优惠买基金&nbsp;
                        <!-- <hk-tip v-if="fundInfo.way === '3'"></hk-tip> -->
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                label="扣款账号："
                prop="pay"
                style="position: relative"
                class="payway-list"
            >
                <el-select
                    v-if="bankLists.length > 0"
                    v-model="fundInfo.pay"
                    placeholder="请选择扣款账号"
                    :class="{ hasVal: bankInfo && bankInfo.label && fundInfo.pay != '' }"
                    v-on:change="bankSel"
                >
                    <el-option-group
                        v-for="(group, index) in bankLists"
                        :key="index"
                        :label="group.label"
                        class="bank-sel"
                    >
                        <el-option
                            v-for="(item, itemIndex) in group.options"
                            :key="item.channelid + itemIndex"
                            :label="
                                item.paycentername +
                                '-' +
                                $cache.getDict('110080', item.bankcode) +
                                '(' +
                                item.depositcard +
                                ')'
                            "
                            :value="item.channelid"
                        >
                            <div v-if="!item.bankAdd" class="bank-info">
                                <img :src="$util.getImg(item.bankcode)" alt="" />
                                <span>{{ item.bankname }}({{ item.depositcard }})</span>
                                <div v-if="item.netnomaxbuy">限额：{{ item.netnomaxbuy }}</div>
                                <!--<span v-if="item.biztype.indexOf('buy') === -1 " style="font-size:13px;color:red">该渠道不支持申购业务</span>-->
                                <p v-if="!item.bankAdd">
                                    {{ item.text }}
                                </p>
                            </div>
                            <div v-if="item.bankAdd" class="option-group clear">
                                {{ item.bankCate }}
                                <el-button
                                    type="blue"
                                    v-on:click.prevent="
                                        $router.push({
                                            name: fundInfo.way === '3' ? 'bank' : 'addbank'
                                        })
                                    "
                                >
                                    {{ item.bankAdd }}
                                </el-button>
                            </div>
                        </el-option>
                    </el-option-group>
                </el-select>
                <div class="hot-area" v-on:click="openDialog"></div>
                <span
                    class="add-bank-btn"
                    style="position: absolute; left: 44%"
                    v-on:click.prevent="
                        $router.push({ name: fundInfo.way === '3' ? 'bank' : 'addbank' })
                    "
                >
                    添加银行卡
                </span>
            </el-form-item>
            <el-form-item :label="buyTypeText + '金额：'" prop="amount" class="form-text">
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="$util.fmtNum(limit.min) + '元起'"
                    :maxlength="14"
                    prefix-icon="fa fa-jpy"
                />
                <p class="buy-range">
                    {{ buyTypeText }}范围 ({{ $util.fmtNum(limit.min) }}元-{{
                        $util.fmtNum(limit.max)
                    }}元)
                    <!-- <span class="upd-pay-edu">修改银行卡支付额度</span> -->
                </p>
                <!-- <p v-if="!fund.comrate" class="redemp-prompt">
                    <i class="el-icon-warning" aria-hidden="true" /><span
                        v-if="false"
                        class="red"
                    >购买金额以10的倍数递增，</span><span>{{ fund.fundtype ===
                        '2'?'货币基金零费率':('买入费率' + fund.feerate) }}</span><span v-if="fund.isBuy===''">{{ '，预计'
                        + $util.fmtDate(fund.cfmdate) }}确认份额</span>
                </p> -->
            </el-form-item>
            <el-form-item label="金额确认：">
                <span class="upper-amount">{{ $util.capitalRMB(fundInfo.amount) }}</span>
            </el-form-item>
            <el-form-item v-show="fundInfo.way == '2' && $util.xjbIsOpen()">
                <div class="flex hcenter">
                    <img
                        v-if="isagreeeasybuy === '1'"
                        src="../../assets/img/circle-checked.png"
                        class="w20 h20 pointer"
                        v-on:click="isagreeeasybuy = '0'"
                    />
                    <img
                        v-if="isagreeeasybuy === '0'"
                        src="../../assets/img/circle-unchecked.png"
                        class="w20 h20 pointer"
                        v-on:click="isagreeeasybuy = '1'"
                    />
                    <div class="ml10">省钱购(自动帮您用钱柜买基金，享0折优惠)</div>
                    <el-tooltip placement="top">
                        <div slot="content">
                            省钱购是什么？
                            <br />
                            银行卡资金将先充值大成钱柜，后自动帮您买入目标基金
                            <br />
                            省钱购有什么好处？
                            <br />
                            购买基金费用可低至0折
                            <br />
                            什么产品支持省钱购？
                            <br />
                            除货币基金外和产品C类份额外，都支持使用省钱购买基金
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </div>
            </el-form-item>
            <el-form-item v-show="feeGate.estimatedcost" label="预估手续费：" class="form-text">
                <span style="color: #f20c00">
                    {{
                        fundInfo.way === "2" && isagreeeasybuy === "1"
                            ? "0.00"
                            : $util.fmtNum(feeGate.estimatedcost)
                    }}元
                </span>
            </el-form-item>
            <el-form-item
                v-if="isPwdCheck"
                label="交易密码："
                prop="pwd"
                :class="{ 'form-text': fund.sign }"
            >
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <!--                <span class="redemp-btn" v-on:click.prevent="$router.push({ name: 'tradepwd' })">-->
                <!--                    <span class="like-a">忘记密码？</span>-->
                <!--                </span>-->
            </el-form-item>
            <el-form-item style="margin-left: -80px">
                <div
                    v-if="readFileInfoList.length !== 0"
                    class="check-box bar-pad showChenckbox"
                    style="font-size: 14px; display: flex; align-items: flex-start"
                >
                    <div style="display: flex; align-items: center">
                        <input v-model="checkbox" type="checkbox" />
                        <span style="padding-left: 5px; color: red">我已阅读并同意:</span>
                    </div>
                    <ul>
                        <li v-for="(item, index) in readFileInfoList" :key="index">
                            <!--<a v-if="item.textaddress.startsWith('http')" v-on:click="getClick(index)" :href="item.textaddress"  style="text-decoration:none; color: red" target="_blank">《{{item.textname}}》</a>-->
                            <!--<span v-else v-on:click="showPdf(item.textaddress)">《{{item.textname}}》</span>-->
                            <a target="_blank" v-on:click="getClick(index)">
                                《{{ item.filename }}》
                            </a>
                        </li>
                    </ul>
                </div>
            </el-form-item>
            <el-form-item>
                <div style="width: 50%">
                    <el-button class="dc-cancel-btn" v-on:click="$router.back()">上一步</el-button>
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="time > 0 || checkBuy == false"
                        v-on:click="submitInfoBefore"
                    >
                        确定
                        <span id="time"></span>
                    </el-button>
                </div>
            </el-form-item>
            <select-bank
                :dialog-bank-lists="dialogBankLists"
                :select-bank-show="cardsDialog"
                v-on:select-bank-close="handleClose"
                v-on:select-bank-info="selectCurCard"
            ></select-bank>
            <el-dialog title="下单确认" :visible.sync="confirmDialog" width="580px">
                <div class="confirm-container confirm-order-text">
                    如您交易日15点前提交申请，可在15点前进行撤单；如您在15点后或节假日提交的申请，在下一交易日15点前可进行撤单，超过时限则不可办理。
                </div>
                <div class="button-container confirm-btn">
                    <div class="btn-confirm cancel" v-on:click="confirmDialog = false">取消</div>
                    <div class="btn-confirm" v-on:click="submitInfo('fundInfo')">确定</div>
                </div>
            </el-dialog>
            <el-dialog
                :title="buyTypeText + '结果'"
                :visible.sync="resultDialog"
                class="prop"
                width="580px"
            >
                <div class="result-container">
                    <img src="@/assets/img/buy_success.png" alt="" srcset="" />
                    <div class="buy-suc">{{ buyTypeText }}买入成功！</div>
                    <div v-if="resultDialogObj.operdatetime" class="buy-suc-time">
                        {{ formatDateTime(resultDialogObj.operdatetime) }}
                    </div>
                </div>
                <div class="result-progress">
                    <div class="red-line"></div>
                    <div class="red-circle"></div>
                    <div class="red-line"></div>
                    <div class="red-circle"></div>
                    <div class="red-line"></div>
                </div>
                <div class="success-time">
                    <div class="time-item">
                        <p>预计{{ $util.fmtDate(resultDialogObj.transactioncfmdate) }}</p>
                        <p>确认份额</p>
                    </div>
                    <div class="time-item">
                        <p>预计{{ $util.fmtDate(resultDialogObj.incomeqrydate) }}</p>
                        <p>查看收益</p>
                    </div>
                </div>
                <div class="button-container confirm-btn">
                    <div class="btn-confirm" v-on:click="sucClick">确定</div>
                </div>
            </el-dialog>
        </el-form>
        <pdf-popup
            base64
            :visible="pdfVisible"
            :need-time="needTime"
            :read-file-info-list="currentFileInfoList"
            v-on:close="finishReading"
        ></pdf-popup>
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <fund-protocol v-if="!buySuccess" v-model="protocol" :fund="fund" v-on:all-read="buyNow" />
        <verifycode-check
            :dialog-visible="checkMobile"
            :mobile="bankInfo.mobile"
            v-on:verify-in="checkVerifyCode"
        />
        <result
            v-if="buySuccess"
            :active="2"
            :result="result"
            v-on:return-page="reset"
            v-on:return-login="$router.push({ name: 'traderecord' })"
        />
    </div>
</template>
<script>
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
import verifycodeCheck from "@/components/form/verifycodeCheck";
import imgCode from "@/components/layout/imgCode.vue";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import userApi from "@/api/user";
import selectBank from "@/components/layout/selectBank.vue";

export default {
    name: "Buy",
    components: {
        PdfPopup,
        result,
        fundProtocol,
        verifycodeCheck,
        imgCode,
        selectBank
    },
    data() {
        return {
            xjbFlag: false,
            xjbBankList: [],
            // 表单信息
            feeH: "", // 费率信息
            fundInfo: {
                amount: "",
                way: "",
                pay: "",
                sharetype: "",
                pwd: "",
                transactionaccountid: "",
                paycenterid: ""
            },
            allBank: [],
            dialogVisible: false,
            btnMsg: "获取短信验证码",
            time: 0, // 验证码再次发送间隔
            isPwdCheck: false, // 是否校验密码
            checkMobile: false, // 短信鉴权验证码显示开关
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的购买申请已提交成功！",
                btnMsg: "预计11月30日以11月29日净值确认份额，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续购买",
                    event: "return-page"
                },
                btnR: {
                    text: "查看交易记录",
                    event: "return-login"
                },
                transfer: {
                    amount: "",
                    acct_name: "",
                    issuring_bank: "",
                    cnaps: "",
                    acct_no: "",
                    big_cnaps: "",
                    bank_exchange_no: ""
                }
            },
            query: null,
            xjbAll: "", // 现金宝总资产
            xjbInfo: [], // 现金宝信息
            fund: {}, // 基金信息获取
            protocol: false,
            bankLists: [], // 银行卡列表
            limit: { text: "起购金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                amount: [{ validator: this.amountLimit, trigger: "blur" }],
                pay: [{ validator: this.validatePayWay, trigger: "change" }],
                selectedBankid_card: [{ validator: this.validateCard, trigger: "change" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            feeGate: {},
            xjbSel: {},
            bankInfo: {}, // 校验银行卡信息
            cfmdate: "", // 确认日期
            checkbox: false, // 阅读确认1
            checkTime: true, // 阅读确认2
            checkBuy: true,
            readFileInfoList: [], // 披露文件信息
            readappno: "", // 申请单编号
            infoText: "",
            isReadFileReading: false,
            currentFileInfoList: [], // 当前阅读信批文件
            pdfVisible: false,
            needTime: false,

            hasBankRroute: false, // 是否开启智能路由
            bankListsOfR: [], // 不区分支付渠道的银行卡信息
            selectedBankid_card: "", // 智能路由下选择的银行卡
            hasAccount: false, // 是否有智能路由推荐渠道下的银行卡
            recChannelid: "", // 推荐的channelid
            recChannelname: "", // 推荐的渠道网点名
            timer: "",
            allBankList: [],
            shareTypeLists: [
                {
                    value: "A",
                    label: "前端收费"
                },
                {
                    value: "B",
                    label: "后端收费"
                }
            ],
            selectShareType: "",
            buyTypeText: "",
            cardsDialog: false,
            confirmDialog: false,
            dialogBankLists: [],
            curSelectCard: {},
            resultDialog: false,
            resultDialogObj: {},
            saveMoneyFlag: false,
            isagreeeasybuy: "0",
            xjbFundCode: "",
            selectCurCardBefore: {},
            info: {}
        };
    },
    watch: {
        "fundInfo.amount"(val) {
            if (this.hasBankRroute && this.fundInfo.way === "2") {
                // 获取智能路由
                this.handleBankRroute();
                return;
            }
            this.isAmount(val);
        },
        "fundInfo.way"(val) {
            this.$refs["fundInfo"].clearValidate();
            this.fundInfo.pay = "";
            this.curIndex = "";
            this.selectCurCardBefore = {
                index: "",
                item: {}
            };
            this.curSelectCard = {};
            this.bankinfo = {};
            let arr = [];
            if (val == "2") {
                arr = this.allBankList.filter((item) => item.payway === val);
            } else {
                arr = this.xjbBankList;
            }
            if (arr.length == 0) {
                this.bankLists = [];
            } else {
                // arr.unshift({
                //     value: "",
                //     bankAdd: "添加银行卡",
                //     bankCate: "",
                //     label: "添加银行卡"
                // });
            }
            let newObj = {
                label: "",
                options: arr
            };
            this.dialogBankLists = arr;

            this.bankLists.shift();
            this.bankLists.push(newObj);
        },
        "fundInfo.sharetype"(val) {
            if (val === "B") {
                this.feeGate = {};
            }
        },
        "fundInfo.pay"(val) {
            if (this.fundInfo.way === "1") {
                const _x = this.xjbInfo.filter((item) => {
                    return item.transid + item.xjbfundcode === val;
                })[0];
                if (_x) {
                    this.xjbSel = _x;
                    const _l =
                        Number(_x.totalasset) > Number(this.fund.xjbmax)
                            ? this.fund.xjbmax
                            : _x.totalasset;
                    this.$set(this.limit, "min", this.fund.xjbmin || "0");
                    this.$set(this.limit, "max", _l);
                } else {
                    this.$set(this.limit, "min", "0");
                    this.$set(this.limit, "max", "0");
                }
                this.pla =
                    this.$util.fmtNum(this.limit.min) +
                    "元起，最多可投" +
                    this.$util.fmtNum(this.limit.max) +
                    "元";
                this.queryRate();
            }
        },
        readFileInfoList: {
            handler: function (obj) {
                if (
                    obj.every(function (item) {
                        return item.read; // 产品概要强制阅读，其他不用
                    })
                ) {
                    this.checkbox = true;
                    // this.checkTime = false;
                }
            },
            deep: true
        },
        checkbox(val) {
            if (
                val &&
                !this.isReadFileReading &&
                this.readFileInfoList.length &&
                !this.readFileInfoList[0].read
            ) {
                this.currentFileInfoList = [this.readFileInfoList[0]];
                this.needTime = true;
                this.pdfVisible = true;
            }
            if (!val) {
                this.readFileInfoList.forEach((item) => (item.read = false));
            }
        },
        selectedBankid_card(val) {
            if (this.fundInfo.way === "2") {
                this.handleBankRroute();
            }
        }
    },
    mounted() {
        let xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
        this.xjbfundcode = xjbFundInfo ? xjbFundInfo.fundcode : "";
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        this.buyTypeText = this.fund.status === "1" ? `认购` : `申购`;
        this.info = this.$cache.getUser();
        this.isagreeeasybuy = this.info.custtag || "0";
        // 组合购买基金数据初始化
        if (this.fund.comrate) {
            this.initComboData();
        }
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        this.getBuyWay();
        this.getFileInfo();
        // 是否开启智能路由
        this.hasBRroute();
    },
    methods: {
        // 是否开启智能路由
        hasBRroute(val) {
            this.hasBankRroute = sessionStorage.getItem("hasBankRroute", "0") != "0";
        },
        // 获取智能路由
        handleBankRroute() {},
        getLimit(channelid) {
            let channel = channelid === "3" ? "hk" : "bank";
            let min = this.$cache.getChannelLimit(channel, "min") || this.fund.min; // 中台配置渠道限额优先取中台配置
            let max = this.$cache.getChannelLimit(channel, "max") || this.fund.max;
            this.$set(this.limit, "min", min);
            this.$set(this.limit, "max", max);
            return this.$util.fmtNum(min) + "元起，最多可投" + this.$util.fmtNum(max) + "元";
        },
        // 获取披露文件信息
        getFileInfo() {
            this.$util.queryReadFileInfo(
                {
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    filetype: ""
                },
                (res) => {
                    res.forEach &&
                        res.forEach((item) => {
                            item.read = false;
                            if (item.filetype.trim() === "1") {
                                // 产品概要
                                this.readFileInfoList.unshift(item);
                            } else {
                                this.readFileInfoList.push(item);
                            }
                        });
                }
            );
        },
        // 获取链接点击事件
        getClick(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading() {
            this.pdfVisible = false;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.isReadFileReading = true;
            }
        },
        validatePayWay(rule, value, callback) {
            if (!value) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }
        },
        validateCard(rule, value, callback) {
            if (!this.selectedBankid_card) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }
        },
        // 再次购买重置表单
        async reset() {
            this.buySuccess = false;
            // this.bankInfo = {};
            // this.bankLists = []
            // this.allBankList = []
            this.$set(this.fundInfo, "amount", "");
            this.$set(this.fundInfo, "pwd", "");
            this.$set(this.fundInfo, "pay", "");
            this.$set(this.fundInfo, "sharetype", "");
            this.$set(this.fundInfo, "transactionaccountid", "");
            this.$set(this.fundInfo, "paycenterid", "");
            // await this.getBuyWay();
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            rule.mes = "购买金额";
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        getVerifyCode(val) {
            this.dialogVisible = false;
            if (val) {
                this.fundInfo.imgCodeVal = val;
                this.$util.getSdxProtocol(this.fund, (res) => {
                    this.fund = res;
                    this.protocol = true;
                });
            }
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate() {
            const _this = this;
            let _d = null;
            if (
                this.fundInfo.amount > 0 &&
                this.fund.sharetype === "A" &&
                ((this.bankInfo.channelid && this.fundInfo.way !== "1") ||
                    (this.xjbSel.xjbfundcode && this.fundInfo.way === "1")) &&
                this.fund.fundtype !== "2"
            ) {
                _d = {
                    fundcode:
                        this.fundInfo.way === "1" ? this.xjbSel.xjbfundcode : this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    applicationamount: this.fundInfo.amount,
                    applicationvol: "0",
                    paymode:
                        this.fundInfo.way == "2" && this.isagreeeasybuy == "1"
                            ? "1"
                            : this.fundInfo.way,
                    businesscode: this.fund.status === "1" ? "20" : "22",
                    channelid:
                        this.fundInfo.way === "1" ? this.xjbSel.channelid : this.bankInfo.channelid
                };
                // if (this.fund.comrate) {
                //     _d.comratelist = this.fund.comrate;
                // }
            }
            this.$util.getFee(_d, (res) => {
                _this.feeGate = res;
                _this.feeH =
                    '<span class="red">' +
                    _this.$util.fmtNum(_this.feeGate.charge) +
                    "元</span>(<s>" +
                    _this.$util.fmtNum(_this.feeGate.originfee) +
                    '</s>元，为您节省<span class="red">' +
                    _this.$util.fmtNum(_this.feeGate.discount) +
                    "</span>元)";
            });
        },
        // 检查是否需要提示新增最优惠渠道卡
        recAddBank() {
            const _this = this;
            let contentText = "";
            _this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (_this.fundInfo.way !== "2" || !_this.hasBankRroute) {
                        _this.submitInfo("fundInfo");
                        return;
                    }
                    if (!_this.hasAccount) {
                        _this.$util.getBankInfo(
                            "acct/addbank/banklist",
                            { biztype2: "" },
                            (res) => {
                                if (
                                    res &&
                                    res.length > 0 &&
                                    !_this.$util.isEmpty(_this.recChannelid)
                                ) {
                                    let canAdd = false; // 是否可以新增推荐渠道下的银行卡
                                    for (let i = 0; i < res.length; i++) {
                                        if (_this.recChannelid === res[i].channelid) {
                                            canAdd = true;
                                            _this.recChannelname =
                                                _this.$cache
                                                    .getDict("110079", res[i].paycenterid)
                                                    .toString()
                                                    .substr(0, 4) +
                                                "-" +
                                                _this.$cache.getDict("110080", res[i].bankid);
                                            contentText =
                                                "使用" +
                                                _this.recChannelname +
                                                "支付更优惠，请添加" +
                                                _this.recChannelname +
                                                "的银行卡";
                                            _this.$util.showMessageBox(
                                                _this,
                                                "温馨提示",
                                                contentText,
                                                "前往增卡",
                                                "继续交易",
                                                function () {
                                                    delete res[i].child;
                                                    sessionStorage.setItem(
                                                        "recBankInfo",
                                                        JSON.stringify(res[i])
                                                    );
                                                    _this.$router.push({ name: "addbank" });
                                                },
                                                function () {
                                                    _this.submitInfo("fundInfo");
                                                }
                                            );
                                            return;
                                        }
                                    }
                                    if (!canAdd) {
                                        _this.submitInfo("fundInfo");
                                    }
                                } else {
                                    _this.submitInfo("fundInfo");
                                }
                            }
                        );
                    } else {
                        _this.submitInfo("fundInfo");
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        submitInfoBefore() {
            this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (this.readFileInfoList.length !== 0) {
                        if (!this.checkbox) {
                            return this.$alert(
                                "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                                "提示",
                                { confirmButtonText: "确定" }
                            );
                        }
                    }
                    this.confirmDialog = true;
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            if (this.readFileInfoList.length !== 0) {
                if (!this.checkbox) {
                    return this.$alert(
                        "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                        "提示",
                        { confirmButtonText: "确定" }
                    );
                }
                /* if(this.checkTime){
                    let noRead = [];
                    this.readFileInfoList.forEach(res => {
                        if(res.texttype === "1" && res.read === false){
                            noRead.push("《"+res.textname+"》");
                        }
                    })
                    return this.$alert('请点击链接阅读'+noRead,'提示',{confirmButtonText:'确定'})
                } */
            }
            // 获取留痕申请编号
            this.$util.writeFileInfo(
                {
                    readFileInfoList: this.readFileInfoList,
                    fundcode: this.fund.fundcode,
                    tano: this.fund.tano
                },
                (res) => {
                    this.readappno = res;
                }
            );

            this.$children[1].index = 0;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.bankInfo.paytype === "1" && this.fundInfo.way === "2") {
                        this.dialogVisible = true;
                    } else {
                        this.$util.getSdxProtocol(this.fund, (res) => {
                            this.fund = res;
                            this.confirmDialog = false;
                            this.protocol = true;
                        });
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        buyFund(val) {
            const _this = this;
            _this.protocol = false;
            if (!val) return;
            if (_this.readFileInfoList.length > 0 && _this.readappno.length === 0) {
                return _this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            let _xjbSel = {};
            if (_this.fundInfo.way === "1") {
                _xjbSel = _this.xjbInfo.filter((item) => {
                    return item.transid + item.xjbfundcode === _this.fundInfo.pay;
                })[0];
            }
            // 现金宝不存在，返回
            if (!_xjbSel) {
                return;
            }
            // 默认参数
            let data = {
                riskwarnflag: _this.fund.riskwarnflag,
                riskmismatchflag: _this.fund.riskmismatchflag,
                highriskwarnflag: _this.fund.highriskwarnflag,
                fundmismatchflag: _this.fund.fundmismatchflag,
                channelid: _this.fundInfo.way === "1" ? "" : _this.bankInfo.value,
                moneyaccount:
                    _this.fundInfo.way === "1" ? _xjbSel.moneyaccount : _this.bankInfo.moneyaccount,
                amount: _this.fundInfo.amount,
                verifycode: _this.fundInfo.imgCodeVal,
                tradepwd: _this.$util.enc(_this.fundInfo.pwd),
                readappno: _this.readappno,
                transactionaccountid: _this.bankInfo.transactionaccountid
            };
            // 现金宝购买新增参数
            if (_this.fundInfo.way === "1") {
                data.fundstatus = _this.fund.fundstatus;
                data.targetsharetype = _this.fundInfo.sharetype;
                data.branchcode = _xjbSel.branchcode;
                data.transactionaccountid = _xjbSel.transid;
                data.xjbfundcode = _xjbSel.xjbfundcode;
            }
            let _url = "trade/buy/orderpay";
            // 组合购买基金新增参数
            if (_this.fund.comrate) {
                data.combinationcode = _this.fund.combinationcode || "";
                data.comfundlist = _this.fund.fundcode;
                data.moneyaccount = _this.bankInfo.moneyaccount;
                data.comratelist = _this.fund.comrate;
                data.comtype = "0";
                _url = "trade/buy/orderpay/combine";
            } else {
                // 普通购买参数添加
                data.targetfundcode = _this.fund.fundcode;
                data.targettano = _this.fund.tano;
                data.targetfundtype = _this.fund.fundtype;
                data.targetfundname = _this.fund.fundname;
                data.payway = _this.fundInfo.way;
                data.sharetype =
                    _this.fundInfo.way === "1"
                        ? _this.xjbInfo[0].sharetype
                        : _this.fundInfo.sharetype;
            }
            if (_this.fundInfo.way === "3") {
                _this.$util.request("umpf/remittance", { status: "3" }).then((res) => {
                    if (res.data) {
                        _this.result.transfer["amount"] = _this.fundInfo.amount;
                        _this.result.transfer["acct_name"] =
                            res.data[0].acct_name.split(/[,，]/)[0];
                        _this.result.transfer["issuring_bank"] =
                            res.data[0].issuring_bank.split(/[,，]/)[0];
                        _this.result.transfer["cnaps"] = res.data[0].cnaps.split(/[,，]/)[0];
                        _this.result.transfer["acct_no"] = res.data[0].acct_no.split(/[,，]/)[0];
                        _this.result.transfer["big_cnaps"] =
                            res.data[0].big_cnaps.split(/[,，]/)[0];
                        _this.result.transfer["bank_exchange_no"] =
                            res.data[0].bank_exchange_no.split(/[,，]/)[0];

                        /* _this.result.transfer = {
                            amount: _this.fundInfo.amount,
                            acct_name: res.data[0].acct_name.split(/[,，]/)[0],
                            bankid: res.data[0].bankid.split(/[,，]/)[0],
                            cnaps: res.data[0].cnaps.split(/[,，]/)[0],
                            acct_no: res.data[0].acct_no.split(/[,，]/)[0],
                            big_cnaps: res.data[0].big_cnaps.split(/[,，]/)[0],
                            bank_exchange_no: res.data[0].bank_exchange_no.split(/[,，]/)[0]
                        }; */
                    }
                });
            }
            // 下单
            _this.$util.request(_url, data, "POST").then((res) => {
                if (!res.data) {
                    _this.resultMes(res);
                }
                // 获取下单时间
                _this.cfmdate = res.data ? res.data[0].incomecaldate : "";
                // 银行卡支付
                // 组合购买
                if (_this.fund.comrate) {
                    _this.resultMes(res);
                    return;
                }
                // 手机验证
                if (_this.bankInfo.paytype === "1" && _this.fundInfo.way === "2") {
                    _this.checkMobile = true;
                    // 后台支付或现金宝购买
                } else if (_this.bankInfo.paytype === "2" || _this.fundInfo.way !== "2") {
                    _this.resultMes(res);
                    // 页面鉴权支付
                } else if (_this.bankInfo.paytype === "3" && _this.fundInfo.way === "2") {
                    const pageUrl = res.data[0].url;
                    _this.$util.newWinOpen(pageUrl);
                    _this.$util.confirmBankAuth(_this, {}, "trade/buy/payresult", function () {
                        let _x = {
                            msg: res.msg,
                            data: []
                        };
                        _this.resultMes(_x);
                    });
                }
            });
        },
        // 获取对应银行卡信息
        async bankSel(val, val2) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.channelid === val) {
                            _this.bankInfo = bank;
                            this.fundInfo.transactionaccountid = bank.transactionaccountid;
                            this.fundInfo.paycenterid = bank.paycenterid;
                            this.$set(this.limit, "min", bank.netnominbuy);
                            this.$set(this.limit, "max", bank.netnomaxbuy);
                            break;
                        }
                    }
                }
            }
            if (this.fundInfo.way === "1") {
                const res = await fundApi.cfgFundrealtimeQueryAll();
                const xjbfundcode = res.data && res.data[0] && res.data[0].fundcode;
                this.xjbFundCode = xjbfundcode;
                if (xjbfundcode) {
                    const res2 = await fundApi.combTransRedeemForBuyLimit({
                        fundcode: xjbfundcode,
                        targetfundcode: this.fund.fundcode,
                        transactionaccountid: this.bankInfo.transactionaccountid
                    });
                    if (res2.data.datalist) {
                        let XjbInfo = res2.data.datalist[0];
                        if (!XjbInfo) {
                            XjbInfo = {};
                            XjbInfo.min = "0";
                            XjbInfo.max = "0";
                        } else {
                            XjbInfo.min = XjbInfo.min ? XjbInfo.min : "0";
                            XjbInfo.max = XjbInfo.max ? XjbInfo.max : "0";
                        }
                        this.$set(this.limit, "min", XjbInfo.min);
                        this.$set(
                            this.limit,
                            "max",
                            Number(XjbInfo.max) - Number(this.bankInfo.xjbasset) > 0
                                ? this.bankInfo.xjbasset
                                : XjbInfo.max
                        );
                    }
                }
            }
            if (this.hasBankRroute && this.fundInfo.way === "2") {
                // 获取智能路由
                this.handleBankRroute();
                return;
            }
            this.queryRate();
        },
        // 获取现金宝信息
        async getBuyWay() {
            this.allBankList = [];
            this.bankLists = [];
            let param = {
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            };
            const res = await fundApi.qryBeforeBuy(param);
            let baseInfo = res.data.returnList1 || {};
            this.fund = Object.assign({}, this.fund, res.data.returnList1);
            try {
                this.xjbFlag = this.$util.xjbIsOpen();
                if (res.data && res.data.returnList2) {
                    res.data.returnList2.forEach((item) => {
                        if (
                            item.paycenterid != "0001" &&
                            item.paycenterid != "1000" &&
                            item.xjbasset &&
                            Number(item.xjbasset) > 0 &&
                            item.banktype != "1"
                        ) {
                            this.xjbBankList.push(item);
                        }
                    });
                }
                const reqRes = await userApi.getMyBankCards();
                if (reqRes.data) {
                    const bankLists = reqRes.data.data;
                    this.xjbBankList.forEach((item1) => {
                        item1.netnomaxbuy = "";
                        item1.perdaymax = "";
                        item1.maxlimitsingle = "";
                        bankLists.forEach((item2) => {
                            if (item1.channelid == item2.paycenterid + item2.bankcode) {
                                item1.netnomaxbuy = item2.maxlimitsingle;
                                item1.perdaymax = item2.perdaymax;
                                item1.maxlimitsingle = item2.maxlimitsingle;
                            }
                        });
                    });
                }
            } catch (e) {
                this.$log.error(e);
            }
            if (baseInfo.hkflag === "1") {
                this.fund.payway = `3`;
            }
            if (baseInfo.payflag === "1") {
                this.fund.payway = `${this.fund.payway},2`;
            }

            let arr = res.data.returnList3.map((item) => {
                return Object.assign(item, {
                    payway: item.hkflag === "1" ? `3` : `2`
                });
            });
            this.allBankList = arr;
            this.allBankList.forEach((item) => {
                item.maxlimitsingle = item.netnomaxbuy;
            });
            let Obj = {
                label: "",
                options: arr
            };
            // this.bankLists.push(Obj)
            this.$set(this.fundInfo, "way", "");
            this.$set(this.fundInfo, "way", "2");
            // this.bankListsOfR = res.data.returnList3
        },
        // 切换为银行卡支付时数据初始化
        // getBank (channelid) {
        //     // 获取银行卡信息
        //     const _x = this.bankLists[0] ? this.bankLists[0].options[1].moneyaccount : "";
        //     if (_x) {
        //         this.$set(this.fundInfo, "pay", _x);
        //         this.bankSel(_x);
        //     }
        //     this.pla = this.getLimit(channelid);
        // },
        // 生成确认信息
        resultMes(res) {
            let code = "1";
            if (res.data) {
                code = (res.data.paystatus && res.data.paystatus.trim()) || "1"; // 支付正在处理中返回p
                this.result.cla = "register-success";
                this.result.btnMsg =
                    "预计确认：" +
                    this.$util.fmtDate(this.cfmdate) +
                    "， 如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            /* if (this.fundInfo.way === "3") {
                this.result.transfer = {
                    remitbankbranch: res.data[0].remitbankbranch.split(/[,，]/)[0],
                    remitacctname: res.data[0].remitacctname.split(/[,，]/)[0],
                    remitcardnum: res.data[0].remitcardnum.split(/[,，]/)[0]
                };
            } */
            let state =
                code === "1"
                    ? "已受理" + (this.result.cla === "register-fail" ? "失败" : "成功")
                    : "正在处理中";
            this.result.msg =
                "您的" +
                (this.fundInfo.way === "1" ? "现金宝" : this.fundInfo.way === "2" ? "" : "汇款") +
                "购买申请" +
                state;
            this.buySuccess = true;
        },
        // 校验用户银行卡手机验证码
        checkVerifyCode(val) {
            this.checkMobile = false;
            if (!val) return false;
            const _this = this;
            this.$util.request("trade/buy/paycheckmsg", { verifycode: val }, "POST").then((res) => {
                let _x = {
                    msg: res.msg
                };
                if (res.data) {
                    res.data[0].status = "1";
                    _x.data = [res.data[0]];
                }
                _this.resultMes(_x);
            });
        },
        // 初始化组合定投数据
        initComboData() {
            this.fund.fundCode = "[" + this.fund.fundcode.replace(/,/g, "] [") + "]";
            this.fund.fundName = "[" + this.fund.fundname.replace(/,/g, "] [") + "]";
            const _x = this.fund.comrate.split(",");
            let _y = "";
            for (let i in _x) {
                _y += "[" + _x[i] * 100 + "%] ";
            }
            this.fund.comRate = _y;
        },
        async buyNow(val) {
            this.protocol = false;
            if (!val) return;
            if (this.fundInfo.way == 2) {
                if (this.isagreeeasybuy !== "1") {
                    try {
                        let data = {
                            fundcode: this.fund.fundcode,
                            sharetype: this.fund.sharetype,
                            paymode: this.fundInfo.way,
                            moneyaccount: this.fundInfo.pay, // 资金账户
                            transactionaccountid: this.fundInfo.transactionaccountid, // 交易账号
                            applicationamount: this.fundInfo.amount, // 申请金额
                            tradepassword: this.$util.enc(this.fundInfo.pwd),
                            paychannel: this.fundInfo.paycenterid,
                            readappno: this.readappno
                        };
                        const res = await fundApi.fundBuyOrderPay(data);
                        if (res.code === "0") {
                            this.resultDialogObj = res.data;
                            this.confirmDialog = false;
                            this.resultDialog = true;
                        } else {
                            this.confirmDialog = false;
                        }
                        this.cfmdate = res.data ? res.data.transactioncfmdate : "";
                    } catch (e) {
                        this.$log.error(e);
                    }
                } else {
                    this.saveMoneyBuy();
                }
            } else {
                try {
                    const res = await fundApi.combTransRealtaRedeemForBuy({
                        transactionaccountid: this.fundInfo.transactionaccountid,
                        tradepassword: this.$util.enc(this.fundInfo.pwd),
                        applicationvol: this.fundInfo.amount,
                        targetfundcode: this.fund.fundcode,
                        redeemmode: "5",
                        largeredemptionflag: "0"
                    });
                    if (res.data.appsheetserialno) {
                        this.resultDialogObj = {
                            transactioncfmdate: res.data.zgtransactioncfmdate,
                            incomeqrydate: res.data.zgincomedate,
                            operdatetime: res.data.operdatetime
                        };
                        this.confirmDialog = false;
                        this.resultDialog = true;
                    } else {
                        this.confirmDialog = false;
                    }
                    this.cfmdate = res.data ? res.data.zgtransactioncfmdate : "";
                } catch (e) {
                    this.$log.error(e);
                }
            }

            // this.resultMes(res);
        },
        async setCusttag() {
            if (
                this.fundInfo.way == "2" &&
                this.isagreeeasybuy == "1" &&
                this.info.custtag === "0"
            ) {
                this.$util.opCustTag("1", this.info);
            }
        },
        openDialog() {
            this.cardsDialog = true;
        },
        handleClose() {
            this.cardsDialog = false;
        },
        selectCurCard(item, index) {
            this.curSelectCard = item;
            this.fundInfo.pay = item.channelid;
            this.bankSel(item.channelid);
        },
        formatDateTime(dateTimeStr) {
            // 将字符串按照一定的格式解析成年、月、日、时、分的部分
            let year = dateTimeStr.substring(0, 4);
            let month = dateTimeStr.substring(4, 6);
            let day = dateTimeStr.substring(6, 8);
            let hour = dateTimeStr.substring(8, 10);
            let minute = dateTimeStr.substring(10, 12);

            // 使用Date对象构造日期时间
            let dateTime = new Date(`${year}-${month}-${day}T${hour}:${minute}`);

            // 格式化日期时间输出
            let formattedDateTime = `${dateTime.getFullYear()}-${this.addLeadingZero(
                dateTime.getMonth() + 1
            )}-${this.addLeadingZero(dateTime.getDate())} ${this.addLeadingZero(
                dateTime.getHours()
            )}:${this.addLeadingZero(dateTime.getMinutes())}`;

            return formattedDateTime;
        },
        addLeadingZero(number) {
            return number < 10 ? "0" + number : number;
        },
        sucClick() {
            this.resultDialog = false;
            this.$router.push({ name: `traderecord` });
        },
        async saveMoneyBuy() {
            try {
                let data = {
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    moneyaccount: this.fundInfo.pay, // 资金账户
                    transactionaccountid: this.fundInfo.transactionaccountid, // 交易账号
                    applicationamount: this.fundInfo.amount, // 申请金额
                    tradepassword: this.$util.enc(this.fundInfo.pwd),
                    paychannel: this.fundInfo.paycenterid,
                    readappno: this.readappno,
                    buymode: "0",
                    relatafundcode: this.xjbfundcode
                };
                const res = await fundApi.combTransBuy(data);
                if (res.error) return;
                if (res.data.appsheetserialno) {
                    this.resultDialogObj = {
                        transactioncfmdate: res.data.transactioncfmdate,
                        incomeqrydate: res.data.incomedate,
                        operdatetime: res.data.operdatetime
                    };
                    this.confirmDialog = false;
                    this.resultDialog = true;
                    this.setCusttag();
                } else {
                    this.confirmDialog = false;
                }
                this.cfmdate = res.data ? res.data.transactioncfmdate : "";
            } catch (e) {
                this.$log.error(e);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.comp-buy {
    padding-bottom: 30px;
    overflow-x: hidden;
    .pwdForm .el-form-item.form-text {
        margin-bottom: 10px;
    }
    .pwdForm .el-form-item.form-nor {
        margin-bottom: 20px;
    }
    .dc-cancel-btn {
        margin-right: 20px;
    }
    .el-button {
        width: 180px;
        height: 42px;
    }
    .el-form-item.payway-list {
        ::v-deep .el-form-item__error.el-form-item__error--inline {
            left: 52%;
        }
    }
}
.add-bank-btn {
    position: absolute;
    left: 52%;
    cursor: pointer;
    color: #1890ff;
    &:hover {
        opacity: 0.7;
    }
}
.buy-range {
    color: #999999;
    .upd-pay-edu {
        font-weight: bold;
        text-decoration: underline;
        color: #333;
        margin-left: 20px;
        cursor: pointer;
    }
}
.payway-list {
    position: relative;
    .hot-area {
        width: 420px;
        height: 40px;
        // background-color: #1890ff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99 !important;
    }
}
.cards-container {
    max-height: 600px;
    overflow-y: auto;
    padding: 40px 20px 0;
    .card-item {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #f1f1f1;
        padding-bottom: 12px;
        margin-bottom: 12px;
        .card-img {
            // display: inline-block;
            width: 30px;
            height: 30px;
            margin-right: 10px;
            position: relative;
            top: 5px;
        }
        .bank-detail {
            flex: 1;
            position: relative;
            .line- {
                color: #999999;
            }
            .line-1 {
                margin-bottom: 6px;
                font-family: Source Han Sans CN;
                font-size: 18px;
                font-weight: normal;
                color: #333333;
            }
            .line-2 {
                font-family: Source Han Sans CN;
                font-size: 14px;
                font-weight: normal;
                color: #999999;
            }
            .el-icon-check {
                color: #f20c00;
                font-size: 18px;
                position: absolute;
                top: 20px;
                font-weight: bold;
                right: 5px;
            }
        }
    }
}
.button-container {
    width: 100%;
    text-align: center;
    .btn-confirm {
        color: #fff;
        background-color: #f20c00;
        width: 150px;
        margin: 30px auto 0;
        padding: 10px 0;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        &:hover {
            opacity: 0.7;
        }
    }
    .cancel {
        color: #333;
        background: #e4e4e4;
    }
}
.confirm-btn {
    display: flex;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #f20c00 !important;
}
.upper-amount {
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    color: #333333;
}
.confirm-order-text {
    color: #333333;
    font-family: Source Han Sans CN;
    font-size: 18px;
    font-weight: normal;
    line-height: 32px;
}
.confirm-container {
    width: 92%;
    margin: 0 auto;
    height: auto;
}
::v-deep .el-dialog__header {
    color: #000;
    background-color: #eeeeee;
    font-weight: bold;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #999999 !important;
}
.result-container {
    margin-top: 20px;
    width: 100%;
    background: #f9f9f9;
    padding: 36px 0;
    text-align: center;
    img {
        width: 100px;
        height: 75px;
        // margin-bottom: 24px;
        margin: 0 auto 24px;
        text-align: center;
    }
    .buy-suc {
        font-family: Source Han Sans CN;
        font-size: 26px;
        font-weight: 500;
        color: #333333;
        margin: 0 auto 24px;
        text-align: center;
    }
    .buy-suc-time {
        font-family: Source Han Sans CN;
        font-size: 18px;
        color: #666666;
        margin: 0 auto;
        text-align: center;
    }
}
.result-progress {
    margin-top: 20px;
    display: flex;
    align-items: center;
    .red-line {
        flex: 1;
        height: 1px;
        background-color: #e60012;
        // width: auto;
    }
    .red-circle {
        width: 14px;
        height: 14px;
        border: 1px solid #e60012;
        border-radius: 50%;
    }
}
.success-time {
    margin-top: 12px;
    display: flex;
    .time-item {
        position: relative;
        flex: 1;
        p:first-child {
            font-size: 18px;
            color: #333333;
            margin-bottom: 10px;
        }
        p {
            color: #999999;
            font-size: 16px;
        }
        &:first-child {
            left: 26%;
        }
        &:last-child {
            left: 10%;
        }
    }
}
</style>
